import { schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';

export const siteValueIsLessThanVacantLandValue: AlertDefinition = ({
  siteValues,
  vacantLandValue,
}) => {
  const subjectSiteValue = siteValues.subject;
  if (
    !vacantLandValue ||
    !subjectSiteValue ||
    subjectSiteValue?.unitAmount > vacantLandValue?.unitAmount
  )
    return undefined;
  return {
    type: schAlertType.parse('siteValueIsLessThanVacantLandValue'),
    status: 'active',
    message: `The Subject's Site Value (${subjectSiteValue.toString()}) should be greater than its projected Vacant Land Value (${vacantLandValue.toString()}).`,
    propertyID: 'subject',
    fixingInfo: {
      tips: 'Tips: Site Extraction value should reflect the combined value of Site Improved and Vacant Land. Review the Vacant Land $/SF charts to confirm your figures before updating the Site Value.',
      pairedCostRouteItem: schPairedCostRouteItem.enum['cost-approach'],
    },
  };
};
